'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

import { useLockBodyScroll } from '@/hooks/useLockBodyScroll';
import { useMediaQuery } from '@/hooks/useMediaQuery';

// Public: Manages navigation overlay state, route-change resets, escape key
// handling, and mobile body scroll locking.
export function useNavigationMenus() {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);
  const [memberMenuOpen, setMemberMenuOpen] = useState(false);
  const [lastPathname, setLastPathname] = useState(pathname);

  if (lastPathname !== pathname) {
    setLastPathname(pathname);

    if (open) {
      setOpen(false);
    }

    if (memberMenuOpen) {
      setMemberMenuOpen(false);
    }
  }

  const isDesktop = useMediaQuery('(min-width: 1024px)');
  useLockBodyScroll((open || memberMenuOpen) && !isDesktop);

  useEffect(() => {
    if (!open && !memberMenuOpen) return;

    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        setOpen(false);
        setMemberMenuOpen(false);
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [memberMenuOpen, open]);

  return {
    closeMemberMenu: () => setMemberMenuOpen(false),
    closeMenu: () => setOpen(false),
    memberMenuOpen,
    open,
    openMemberMenu: () => setMemberMenuOpen(true),
    toggleMenu: () => setOpen(currentOpen => !currentOpen),
  };
}
